module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f603.66f6c781.svg";